(function () {
  'use strict';
  var T = window.theme || {};
  var routes = T.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js' };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function rafThrottle(fn){ var ticking=false; return function(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ fn(); ticking=false; }); }; }

  /* ---------- money formatting ---------- */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var fmt = T.moneyFormat || '${{amount}}';
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas + ',' + parts[1]);
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('toast');
  var toastText = document.getElementById('toast-text');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastText.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2000);
  }

  /* ---------- cart drawer ---------- */
  var els = {
    overlay: document.getElementById('cart-overlay'),
    drawer: document.getElementById('cart'),
    items: document.getElementById('cart-items'),
    foot: document.getElementById('cart-foot'),
    count: document.getElementById('cart-count'),
    dot: document.getElementById('cart-dot'),
    subtotal: document.getElementById('cart-subtotal')
  };
  function openCart() { if (els.overlay) els.overlay.classList.add('open'); if (els.drawer) els.drawer.classList.add('open'); }
  function closeCart() { if (els.overlay) els.overlay.classList.remove('open'); if (els.drawer) els.drawer.classList.remove('open'); }
  var cartOpenBtn = document.getElementById('cart-open');
  var cartCloseBtn = document.getElementById('cart-close');
  if (cartOpenBtn) cartOpenBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (els.overlay) els.overlay.addEventListener('click', closeCart);

  function renderCart(cart) {
    if (els.count) els.count.textContent = cart.item_count;
    if (els.dot) {
      if (cart.item_count > 0) { els.dot.style.display = 'flex'; els.dot.textContent = cart.item_count; }
      else { els.dot.style.display = 'none'; }
    }
    if (!els.items) return;
    if (cart.item_count === 0) {
      els.items.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      if (els.foot) els.foot.style.display = 'none';
      return;
    }
    els.items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? '<div class="s">' + it.variant_title + '</div>' : '';
      return '<div class="cart-row" data-key="' + it.key + '">' +
        '<img src="' + img + '" alt="">' +
        '<div style="flex:1">' +
          '<div class="n">' + it.product_title + '</div>' + variant +
          '<div class="p">' + formatMoney(it.final_line_price) + '</div>' +
          '<button class="rm" data-key="' + it.key + '">Remove</button>' +
        '</div></div>';
    }).join('');
    if (els.foot) els.foot.style.display = 'block';
    if (els.subtotal) els.subtotal.textContent = formatMoney(cart.total_price);
    els.items.querySelectorAll('.rm').forEach(function (b) {
      b.addEventListener('click', function () { changeLine(b.dataset.key, 0); });
    });
  }

  function refreshCart(open) {
    return fetch(routes.cart, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); if (open) openCart(); return cart; });
  }

  function addToCart(id, qty, name) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Could not add to cart'); return; }
        toast((name || res.product_title || 'Item') + ' added to cart');
        return refreshCart(true);
      }).catch(function () { toast('Could not add to cart'); });
  }

  function changeLine(key, qty) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  /* product add-to-cart form */
  var pForm = document.getElementById('product-form');
  if (pForm) {
    pForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var idField = document.getElementById('variant-id');
      var id = idField ? idField.value : null;
      var nameEl = document.querySelector('.pdp-name');
      if (id) addToCart(id, 1, nameEl ? nameEl.textContent.trim() : '');
    });
  }

  /* variant picker -> set hidden id + price */
  var variantsTag = document.getElementById('product-variants');
  if (variantsTag) {
    var variants = JSON.parse(variantsTag.textContent || '[]');
    var optionSelects = [].slice.call(document.querySelectorAll('.pdp-variants select'));
    var hiddenId = document.getElementById('variant-id');
    var priceEl = document.getElementById('pdp-price');
    var addBtn = document.getElementById('add-cart');
    function updateVariant() {
      var chosen = optionSelects.map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;
      if (hiddenId) hiddenId.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to Cart' : 'Sold out';
      }
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });

    /* strap swatches: each selects a variant directly */
    var strapOpts = [].slice.call(document.querySelectorAll('.pdp-strap-opt'));
    function selectVariant(v) {
      if (!v) return;
      if (hiddenId) hiddenId.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to Cart' : 'Sold out';
      }
    }
    strapOpts.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var v = variants.find(function (x) { return String(x.id) === String(btn.dataset.variantId); });
        selectVariant(v);
        strapOpts.forEach(function (b) { b.classList.toggle('active', b === btn); });
      });
    });
  }

  /* home: card add-to-cart buttons */
  document.querySelectorAll('.card-atc').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('[data-variant-id]');
      if (card) addToCart(card.dataset.variantId, 1, card.dataset.name);
    });
  });

  /* home: mood tiles -> go to product (or add) */
  document.querySelectorAll('.mood').forEach(function (m) {
    m.addEventListener('click', function () {
      if (m.dataset.href) { window.location.href = m.dataset.href; return; }
      if (m.dataset.variantId) addToCart(m.dataset.variantId, 1, m.dataset.name);
    });
  });

  /* product cards: click anywhere (incl. Explore) opens the product.
     A swipe on the gallery sets _dragged so it won't navigate. */
  document.querySelectorAll('.card[data-href]').forEach(function (card) {
    card.style.cursor = 'pointer';
    card.addEventListener('click', function (e) {
      if (e.target.closest('.card-atc')) return;
      if (e.target.closest('.garr') || e.target.closest('.gdot')) return;
      if (card._dragged) { card._dragged = false; return; }
      if (card.dataset.href) window.location.href = card.dataset.href;
    });
  });

  /* cart is server-rendered on load — no initial fetch needed */

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.16 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- nav scroll state ---------- */
  var nav = document.getElementById('nav');
  if (nav) {
    var isProduct = nav.dataset.template === 'product';
    if (isProduct) {
      var navMark = nav.querySelector('.nav-left .mark');
      var navWord = nav.querySelector('.nav-center .word');
      var tabsEl = document.getElementById('pdp-tabs');
      function syncTabsTop() { if (tabsEl) tabsEl.style.top = Math.round(nav.getBoundingClientRect().height) + 'px'; }
      function navState() {
        var light = window.scrollY < 40;
        nav.classList.toggle('nav-light', light);
        nav.classList.toggle('scrolled', !light);
        if (navMark && T.assets) navMark.src = light ? T.assets.logoDark : T.assets.logoWhite;
        if (navWord && T.assets) navWord.src = light ? T.assets.wordDark : T.assets.wordWhite;
        syncTabsTop();
      }
      window.addEventListener('scroll', rafThrottle(navState), { passive: true });
      window.addEventListener('resize', syncTabsTop);
      nav.addEventListener('transitionend', syncTabsTop);
      navState();
    } else {
      window.addEventListener('scroll', rafThrottle(function () { nav.classList.toggle('scrolled', window.scrollY > 40); }), { passive: true });
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }
  }

  /* ---------- galleries (cards + product) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('.gtrack');
    var slides = gal.querySelectorAll('.gslide');
    var n = slides.length;
    if (n < 2) return;
    var index = 0, startX = 0, dx = 0, dragging = false, width = 1;
    var media = gal.parentNode;
    var isPdp = !!media.querySelector('#pdp-thumbs') || !!document.getElementById('pdp-thumbs') && media.classList.contains('pdp-stage');

    var prev = document.createElement('button'); prev.className = 'garr prev'; prev.innerHTML = '&lsaquo;';
    var next = document.createElement('button'); next.className = 'garr next'; next.innerHTML = '&rsaquo;';
    media.appendChild(prev); media.appendChild(next);

    var dots = null, thumbs = null;
    var thumbWrap = media.querySelector('#pdp-thumbs') || document.getElementById('pdp-thumbs');
    if (thumbWrap && media.contains(thumbWrap)) {
      thumbs = thumbWrap.querySelectorAll('.pdp-thumb');
    } else {
      dots = document.createElement('div'); dots.className = 'gdots';
      for (var i = 0; i < n; i++) {
        var d = document.createElement('button'); d.className = 'gdot' + (i === 0 ? ' active' : ''); d.dataset.i = i;
        dots.appendChild(d);
      }
      media.appendChild(dots);
    }

    function go(i) {
      index = (i + n) % n;
      track.classList.remove('no-anim');
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      if (dots) dots.querySelectorAll('.gdot').forEach(function (dt, j) { dt.classList.toggle('active', j === index); });
      if (thumbs) thumbs.forEach(function (t, j) { t.classList.toggle('active', j === index); });
    }
    function stop(e) { e.stopPropagation(); }
    prev.addEventListener('click', function (e) { stop(e); go(index - 1); resetAuto(); });
    next.addEventListener('click', function (e) { stop(e); go(index + 1); resetAuto(); });
    if (dots) dots.querySelectorAll('.gdot').forEach(function (dt) { dt.addEventListener('click', function (e) { stop(e); go(+dt.dataset.i); resetAuto(); }); });
    if (thumbs) thumbs.forEach(function (t) { t.addEventListener('click', function (e) { stop(e); go(+t.dataset.i); }); });

    var autoTimer = null;
    function startAuto() { if (autoTimer || dots === null || reduceMotion) return; autoTimer = setInterval(function () { if (!dragging) go(index + 1); }, 1500); }
    function stopAuto() { if (autoTimer) { clearInterval(autoTimer); autoTimer = null; } }
    function resetAuto() { if (autoTimer) { stopAuto(); startAuto(); } }
    if (dots) { media.addEventListener('mouseenter', startAuto); media.addEventListener('mouseleave', stopAuto); }

    var hostCard = gal.closest('.card[data-href]');
    gal.addEventListener('pointerdown', function (e) {
      dragging = true; startX = e.clientX; dx = 0; width = gal.offsetWidth || 1;
      if (hostCard) hostCard._dragged = false;
      gal.classList.add('dragging'); track.classList.add('no-anim'); gal.setPointerCapture(e.pointerId);
    });
    gal.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      if (hostCard && Math.abs(dx) > 6) hostCard._dragged = true;
      track.style.transform = 'translateX(' + (-index * 100 + (dx / width) * 100) + '%)';
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false; gal.classList.remove('dragging');
      if (Math.abs(dx) > width * 0.16) go(index + (dx < 0 ? 1 : -1)); else go(index);
      dx = 0; resetAuto();
    }
    gal.addEventListener('pointerup', endDrag);
    gal.addEventListener('pointercancel', endDrag);
  });

  /* ---------- product tabs: smooth-scroll + scroll-spy ---------- */
  var tabs = [].slice.call(document.querySelectorAll('.pdp-tab'));
  if (tabs.length) {
    var NAVOFF = 110;
    tabs.forEach(function (tb) {
      tb.addEventListener('click', function () {
        var el = document.getElementById(tb.dataset.target);
        if (!el) return;
        var y = el.getBoundingClientRect().top + window.scrollY - NAVOFF;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
    var spySections = tabs.map(function (tb) { return document.getElementById(tb.dataset.target); });
    function spy() {
      var line = NAVOFF + 50, active = 0;
      spySections.forEach(function (s, i) { if (s && s.getBoundingClientRect().top <= line) active = i; });
      tabs.forEach(function (tb, i) { tb.classList.toggle('active', i === active); });
    }
    window.addEventListener('scroll', rafThrottle(spy), { passive: true });
    spy();
  }

  /* ---------- design horizontal scroll ---------- */
  var dscroll = document.getElementById('design-scroll');
  if (dscroll) {
    var dPrev = document.getElementById('dscroll-prev');
    var dNext = document.getElementById('dscroll-next');
    function dStep() { var t = dscroll.querySelector('.design-tile'); return t ? t.offsetWidth + 24 : 340; }
    function dUpdate() {
      var max = dscroll.scrollWidth - dscroll.clientWidth - 2;
      if (dPrev) dPrev.disabled = dscroll.scrollLeft <= 2;
      if (dNext) dNext.disabled = dscroll.scrollLeft >= max;
    }
    if (dPrev) dPrev.addEventListener('click', function () { dscroll.scrollBy({ left: -dStep(), behavior: 'smooth' }); });
    if (dNext) dNext.addEventListener('click', function () { dscroll.scrollBy({ left: dStep(), behavior: 'smooth' }); });
    dscroll.addEventListener('scroll', dUpdate, { passive: true });
    window.addEventListener('resize', dUpdate);
    dUpdate();
  }

  /* ---------- mobile menu ---------- */
  var mMenu = document.getElementById('m-menu');
  var mOverlay = document.getElementById('m-menu-overlay');
  var mBurger = document.getElementById('nav-burger');
  if (mMenu && mBurger) {
    function openMenu() { mMenu.classList.add('open'); mOverlay.classList.add('open'); mBurger.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeMenu() { mMenu.classList.remove('open'); mOverlay.classList.remove('open'); mBurger.classList.remove('open'); document.body.style.overflow = ''; }
    mBurger.addEventListener('click', function () { mMenu.classList.contains('open') ? closeMenu() : openMenu(); });
    var mClose = document.getElementById('m-menu-close');
    if (mClose) mClose.addEventListener('click', closeMenu);
    if (mOverlay) mOverlay.addEventListener('click', closeMenu);
    mMenu.querySelectorAll('.m-menu-links a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  }
})();


/* ---------- mobile image zoom / lightbox (product page) ---------- */
(function () {
  var stage = document.querySelector('.pdp-stage [data-gallery]') || document.querySelector('.pdp-stage');
  if (!stage) return;
  var scope = document.querySelector('.pdp-stage') || stage;
  var galImgs = [].slice.call(scope.querySelectorAll('img.gslide'));
  if (!galImgs.length) return;

  /* self-contained styles so this never depends on site.css */
  var css = '.pz{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.94);display:none;touch-action:none;overscroll-behavior:contain;}' +
    '.pz.open{display:block;}' +
    '.pz-track{display:flex;height:100%;width:100%;will-change:transform;}' +
    '.pz-slide{flex:0 0 100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;}' +
    '.pz-slide img{max-width:100%;max-height:100%;transform-origin:center center;will-change:transform;-webkit-user-drag:none;user-select:none;}' +
    '.pz-close{position:absolute;top:calc(env(safe-area-inset-top,0px) + 12px);right:14px;z-index:2;width:42px;height:42px;padding:0;border:0;border-radius:50%;background:rgba(0,0,0,.45);color:#fff;font-size:26px;line-height:42px;text-align:center;cursor:pointer;}' +
    '.pz-count{position:absolute;top:calc(env(safe-area-inset-top,0px) + 20px);left:16px;z-index:2;color:#fff;font-size:13px;letter-spacing:.12em;opacity:.85;}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function hi(src) {
    if (!src) return src;
    var base = src.split('?')[0].replace(/_\d{2,4}x(\d{2,4})?(?=\.[a-zA-Z]{2,5}$)/, '');
    return base + '?width=1600';
  }
  var urls = galImgs.map(function (img) { return hi(img.currentSrc || img.src); });
  var n = urls.length;

  var lb = document.createElement('div');
  lb.className = 'pz';
  lb.innerHTML = '<button class="pz-close" type="button" aria-label="Close">\u00d7</button><div class="pz-count"></div><div class="pz-track"></div>';
  document.body.appendChild(lb);
  var track = lb.querySelector('.pz-track');
  var countEl = lb.querySelector('.pz-count');
  urls.forEach(function (u) {
    var s = document.createElement('div'); s.className = 'pz-slide';
    var im = document.createElement('img'); im.src = u; im.alt = ''; im.draggable = false;
    s.appendChild(im); track.appendChild(s);
  });
  var imgs = [].slice.call(track.querySelectorAll('.pz-slide img'));

  var index = 0, scale = 1, tx = 0, ty = 0;

  function applyImg() { var im = imgs[index]; if (im) im.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
  function resetZoom() { scale = 1; tx = 0; ty = 0; if (imgs[index]) imgs[index].style.transform = ''; }
  function setTrack(animate) { track.style.transition = animate ? 'transform .28s ease' : 'none'; track.style.transform = 'translateX(' + (-index * 100) + '%)'; }
  function setIndex(i, animate) { resetZoom(); index = (i + n) % n; setTrack(animate); countEl.textContent = (index + 1) + ' / ' + n; }

  function openAt(i) { setIndex(i, false); lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close() {
    lb.classList.remove('open'); document.body.style.overflow = ''; lb.style.background = ''; resetZoom();
    var t = document.querySelector('.pdp-thumb[data-i="' + index + '"]');
    if (t) t.click();
  }

  /* which gallery image is showing right now */
  function currentIndex() {
    var a = document.querySelector('.pdp-thumb.active');
    if (a && a.dataset.i != null) { var v = parseInt(a.dataset.i, 10); if (!isNaN(v)) return v; }
    return 0;
  }

  /* open on a TAP anywhere on the gallery image (not arrows/dots/thumbs, not a swipe).
     Uses pointer events on the stage so it survives the gallery's pointer capture. */
  scope.addEventListener('pointerdown', function (e) {
    scope._x = e.clientX; scope._y = e.clientY; scope._drag = false;
    scope._openable = !!(e.target && e.target.closest && e.target.closest('.gallery'));
  });
  scope.addEventListener('pointermove', function (e) {
    if (scope._x != null && (Math.abs(e.clientX - scope._x) > 8 || Math.abs(e.clientY - scope._y) > 8)) scope._drag = true;
  });
  scope.addEventListener('pointerup', function () {
    if (scope._openable && !scope._drag) openAt(currentIndex());
    scope._openable = false;
  });
  galImgs.forEach(function (img) { img.style.cursor = 'zoom-in'; });

  lb.querySelector('.pz-close').addEventListener('click', close);
  lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') setIndex(index + 1, true);
    else if (e.key === 'ArrowLeft') setIndex(index - 1, true);
  });

  /* ---- touch gestures: swipe between, pinch + double-tap zoom, pan, swipe-down to close ---- */
  var startX = 0, startY = 0, mode = null, lastTap = 0, pinch = null, panStart = null;
  function dist(a, b) { return Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY); }
  function clampPan() {
    var im = imgs[index]; if (!im) return;
    var scaledW = im.clientWidth * scale, scaledH = im.clientHeight * scale;
    var maxX = Math.max(0, (scaledW - window.innerWidth) / 2), maxY = Math.max(0, (scaledH - window.innerHeight) / 2);
    tx = Math.min(maxX, Math.max(-maxX, tx)); ty = Math.min(maxY, Math.max(-maxY, ty));
  }
  function toggleZoom(px, py) {
    if (scale > 1) { resetZoom(); return; }
    scale = 2.5;
    var im = imgs[index], r = im.getBoundingClientRect();
    tx = -(px - (r.left + r.width / 2)) * (scale - 1);
    ty = -(py - (r.top + r.height / 2)) * (scale - 1);
    clampPan(); applyImg();
  }

  track.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) { pinch = { d0: dist(e.touches[0], e.touches[1]), s0: scale }; mode = 'pinch'; return; }
    var t = e.touches[0];
    startX = t.clientX; startY = t.clientY;
    if (scale > 1) { mode = 'pan'; panStart = { x: t.clientX, y: t.clientY, tx: tx, ty: ty }; }
    else { mode = null; }
    var now = Date.now();
    if (now - lastTap < 300) { e.preventDefault(); toggleZoom(t.clientX, t.clientY); lastTap = 0; } else { lastTap = now; }
  }, { passive: false });

  track.addEventListener('touchmove', function (e) {
    if (mode === 'pinch' && e.touches.length === 2) {
      e.preventDefault();
      scale = Math.min(4, Math.max(1, pinch.s0 * (dist(e.touches[0], e.touches[1]) / pinch.d0)));
      applyImg(); return;
    }
    if (e.touches.length !== 1) return;
    var t = e.touches[0], dx = t.clientX - startX, dy = t.clientY - startY;
    if (mode === 'pan' && scale > 1) { e.preventDefault(); tx = panStart.tx + (t.clientX - panStart.x); ty = panStart.ty + (t.clientY - panStart.y); clampPan(); applyImg(); return; }
    if (mode === null) {
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) mode = 'swipe';
      else if (dy > 8 && dy > Math.abs(dx)) mode = 'close';
    }
    if (mode === 'swipe') { e.preventDefault(); track.style.transition = 'none'; track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + dx + 'px))'; }
    else if (mode === 'close') { e.preventDefault(); lb.style.background = 'rgba(0,0,0,' + Math.max(0, 0.94 - dy / 500) + ')'; track.style.transition = 'none'; track.style.transform = 'translateX(' + (-index * 100) + '%) translateY(' + dy + 'px)'; }
  }, { passive: false });

  track.addEventListener('touchend', function (e) {
    if (mode === 'pinch') { if (scale <= 1.02) resetZoom(); mode = null; pinch = null; return; }
    var end = e.changedTouches[0];
    if (mode === 'swipe') { var dx = end.clientX - startX; if (Math.abs(dx) > window.innerWidth * 0.18) setIndex(index + (dx < 0 ? 1 : -1), true); else setTrack(true); }
    else if (mode === 'close') { var dy = end.clientY - startY; if (dy > 120) { close(); } else { lb.style.background = ''; setTrack(true); } }
    mode = null;
  });
})();